import { Pipe, PipeTransform } from '@angular/core';
import { differenceBy, List, ValueIteratee } from 'lodash';

@Pipe({
  name: 'differenceBy',
  standalone: true,
})
export class DifferenceByPipe implements PipeTransform {
  transform<T1, T2>(
    value: List<T1> | null | undefined,
    values: List<T2>,
    iteratee: ValueIteratee<T1 | T2>
  ): T1[] {
    return differenceBy(value, values, iteratee);
  }
}
